import { getBaseRequestUrl, getToken } from './constants';
import { message } from "antd";

interface FilrResponse {
    retCode: number,
    retData: string,
    retMsg: string,
    success: boolean,
    [key:string]:any
}
interface File {
    uid?: string,
    name?: string,
    status?: string,
    response: FilrResponse,
    linkProps?: any
}
interface Upload {
    file: File,
    fileList: any,
    event: any
}

export function importPropsConfig(url: string, callback: any): object {
    let cfg = {
        name: 'file',
        action: getBaseRequestUrl() + url,
        headers: {
            authorization: getToken(),
        },
        onChange(info: Upload) {
            console.log(info)
            if (info.file.status === 'done' && info.file.response.retCode === 200) {
                message.success({ content: `${info.file.name}导入${info.file.response.retData}`, duration: 8 });
                callback && callback()
            }else if(info.file.status === 'done' && info.file.response.list.length !== 0){
                message.success({ content: `${info.file.name}导入${info.file.response.msg}`, duration: 8 });
                callback && callback(info.file.response.list)
            } else if (info.file.status === 'error') {
                message.error(`${info.file.response.retData}：${info.file.name}导入异常，请尝试重新导入`);
            }
        },
    }
    return cfg
}